import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleLandingCompact } from '../components/layout/module-landing-compact';
import { Package, BarChart3, FileText, MessageCircle, Layout, Palette, Grid3x3, List, Calendar, CheckSquare, Circle, Bell, Shield, Settings, Loader, Type, Layers, Eye, RefreshCw } from 'lucide-react';
const compactCategories = [
    {
        id: 'core-ui',
        title: 'Core UI',
        description: 'Essential building blocks',
        icon: _jsx(Package, { className: "w-4 h-4" }),
        color: 'blue',
        items: [
            {
                label: 'Buttons',
                path: '/ui-examples/buttons',
                description: 'Interactive buttons with variants',
                icon: _jsx(Type, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Cards',
                path: '/ui-examples/cards',
                description: 'Content containers',
                icon: _jsx(Layers, { className: "w-3.5 h-3.5" })
            }
        ]
    },
    {
        id: 'data-display',
        title: 'Data Display',
        description: 'Tables and lists',
        icon: _jsx(BarChart3, { className: "w-4 h-4" }),
        color: 'green',
        items: [
            {
                label: 'Data Tables',
                path: '/ui-examples/tables',
                description: 'Advanced tables with filtering',
                icon: _jsx(Grid3x3, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Virtual Table',
                path: '/ui-examples/virtual-table',
                description: 'High-performance scrolling',
                icon: _jsx(Eye, { className: "w-3.5 h-3.5" }),
                badge: 'NEW'
            },
            {
                label: 'Table Grouping',
                path: '/ui-examples/virtual-table-grouping',
                description: 'Multi-level grouping',
                icon: _jsx(Layers, { className: "w-3.5 h-3.5" }),
                badge: 'NEW'
            },
            {
                label: 'Virtual List',
                path: '/ui-examples/virtual-list',
                description: 'Large lists with virtual scrolling',
                icon: _jsx(List, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Infinite Scroll',
                path: '/ui-examples/infinite-scroll',
                description: 'Load content as users scroll',
                icon: _jsx(RefreshCw, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Pagination + Virtual',
                path: '/ui-examples/pagination-virtual',
                description: 'Combine pagination with performance',
                icon: _jsx(Grid3x3, { className: "w-3.5 h-3.5" })
            }
        ]
    },
    {
        id: 'forms-inputs',
        title: 'Forms',
        description: 'Form components',
        icon: _jsx(FileText, { className: "w-4 h-4" }),
        color: 'purple',
        items: [
            {
                label: 'Basic Forms',
                path: '/ui-examples/forms',
                description: 'Input fields and validation',
                icon: _jsx(FileText, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Adaptive Forms',
                path: '/ui-examples/adaptive-forms',
                description: 'Single form, multiple layouts',
                icon: _jsx(Layers, { className: "w-3.5 h-3.5" }),
                badge: 'NEW'
            },
            {
                label: 'Checkbox',
                path: '/ui-examples/checkbox',
                description: 'Modern checkboxes',
                icon: _jsx(CheckSquare, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Radio Buttons',
                path: '/ui-examples/radio',
                description: 'Modern radio buttons',
                icon: _jsx(Circle, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Date Pickers',
                path: '/ui-examples/datepicker',
                description: 'Date and time pickers',
                icon: _jsx(Calendar, { className: "w-3.5 h-3.5" })
            }
        ]
    },
    {
        id: 'feedback-overlays',
        title: 'Feedback',
        description: 'User feedback',
        icon: _jsx(MessageCircle, { className: "w-4 h-4" }),
        color: 'orange',
        items: [
            {
                label: 'Modals',
                path: '/ui-examples/modals',
                description: 'Dialog boxes and wizards',
                icon: _jsx(Layout, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Loading States',
                path: '/ui-examples/loading',
                description: 'Spinners and skeletons',
                icon: _jsx(Loader, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Alerts & Toasts',
                path: '/ui-examples/alerts',
                description: 'Alert messages and notifications',
                icon: _jsx(Bell, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Error Boundaries',
                path: '/ui-examples/error-boundaries',
                description: 'Error handling and recovery',
                icon: _jsx(Shield, { className: "w-3.5 h-3.5" })
            }
        ]
    },
    {
        id: 'layouts',
        title: 'Layout',
        description: 'Page layouts',
        icon: _jsx(Layout, { className: "w-4 h-4" }),
        color: 'indigo',
        items: [
            {
                label: 'Page Layouts',
                path: '/ui-examples/layouts',
                description: 'Complete page patterns',
                icon: _jsx(Layout, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Compact Landing',
                path: '/ui-examples/module-landing-compact',
                description: 'This component!',
                icon: _jsx(Grid3x3, { className: "w-3.5 h-3.5" }),
                badge: 'YOU ARE HERE'
            }
        ]
    },
    {
        id: 'theming',
        title: 'Theming',
        description: 'Visual themes',
        icon: _jsx(Palette, { className: "w-4 h-4" }),
        color: 'red',
        collapsed: true,
        items: [
            {
                label: 'Theme System',
                path: '/ui-examples/themes',
                description: '6 built-in color presets',
                icon: _jsx(Palette, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Color Customization',
                path: '/ui-examples/themes',
                description: 'Custom theme variables',
                icon: _jsx(Settings, { className: "w-3.5 h-3.5" })
            }
        ]
    }
];
export const UIExamplesCompactLanding = ({ onNavigate }) => {
    return (_jsx(ModuleLandingCompact, { title: "UI Component Library", description: "A comprehensive design system with 20+ components and 6 theme presets", categories: compactCategories, onNavigate: onNavigate, showSearch: true, showViewToggle: true, defaultView: "compact", maxColumns: 4, className: "h-full" }));
};
